import axios from 'axios'
import toastStore from '@/stores/toast-store.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import image from '@/assets/images/empty_deliveries.png'
import parentRoute from '@/mixins/parent-route.js'

export default {
  name: 'ProfileCollectomates',
  mixins: [CurrentUserResolver, parentRoute],
  data: function () {
    return {
      collectomates: [],
      image: image,
      blocker: false,
    }
  },
  mounted() {
    this.fetchCollectomates()
  },
  methods: {
    fetchCollectomates: function () {
      this.blocker = true
      axios({
        method: 'get',
        url: 'collection_points',
      })
        .then(response => {
          this.collectomates = response.data
          this.blocker = false
          console.log('response', response)
        })
        .catch(error => {
          let errorMessage = !!error.response.data.errors
            ? Object.values(error.response.data.errors).join(', ')
            : this.$t('messages.error')
          toastStore.commit('error', { message: errorMessage })
          this.blocker = false
        })
    },
    isDeliveryKeyRequiredForCP: collectomate => {
      if (collectomate.deliveryScenarios.length > 0) {
        if (collectomate.deliveryScenarios[0] === 'by_user') {
          return true
        } else if (collectomate.deliveryScenarios[0] === 'by_deliverer') {
          return false
        }
      }
    },
    displayInfoCodeRequired() {
      toastStore.commit('error', {
        message: this.$t('profile.myCollectomates.deliveryCodeRequiredToast'),
      })
    },
    displayInfoNoCodeRequired() {
      toastStore.commit('error', {
        message: this.$t('profile.myCollectomates.deliveryCodeNotRequiredToast'),
      })
    },
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
